import React, {useState} from 'react'
import './cform.less'
import axios from 'axios'

export default ()=>{
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    return(
        <section className="home-contact-form">
            <div className="heading">
                <h2>contact us</h2>
                <div className="underline"></div>
            </div>
            <article className="form-container anim-two" data-delay="0s">
                <form action="https://formspree.io/f/mbjpzypr" method="POST" name="Contact Form">
                    <article className="form-grid">
                        <div className="anim-two" data-delay="0.2s">
                            <input type="text" id="firstname" className={`${firstName? "has-content": ""}`} name="First Name" value={firstName} onChange={e => setFirstName(e.target.value)}/>
                            <label htmlFor="firstname">First Name</label>
                        </div>
                        <div className="anim-two" data-delay="0.4s">
                            <input type="text" id="lastname" className={`${lastName? "has-content": ""}`} name="Last Name" value={lastName} onChange={e => setLastName(e.target.value)}/>
                            <label htmlFor="lastname">Last Name</label>
                        </div>
                    </article>
                    <article className="form-grid">
                        <div className="anim-two" data-delay="0.6s">
                            <input type="email" id="email" className={`${email? "has-content": ""}`} name="Email" value={email} onChange={e => setEmail(e.target.value)}/>
                            <label htmlFor="email">Email</label>
                        </div>
                        <div className="anim-two" data-delay="0.8s">
                            <input type="tel" id="phone" className={`${phone? "has-content": ""}`} name="Telephone" value={phone} onChange={e => setPhone(e.target.value)}/>
                            <label htmlFor="phone">Phone</label>
                        </div>
                    </article>
                    <div className="anim-two" data-delay="1.0s">
                        <input type="text" id="subject" className={`${subject? "has-content": ""}`} name="Subject" value={subject} onChange={e => setSubject(e.target.value)}/>
                        <label htmlFor="subject">Subject</label>
                    </div>
                    <div className="anim-two" data-delay="1.2s">
                        <input type="textarea" cols="30" rows="10" id="message" className={`textarea ${message? "has-content": ""}`} name="Message" value={message} onChange={e => setMessage(e.target.value)}/>
                        <label htmlFor="message">Message</label>
                    </div>
                    <input type="submit" value="Submit" className="btn anim-two"  data-delay="1.4s"/>
                    <p>message successfully sent</p>
                </form>
            </article>
        </section>
    )
}